import queryString from 'query-string'
import { handleError } from '@/utils/commonUtils'

/**
 * Gọi API qua ApisServiceApp: lỗi async (HTTP/network) được handleError + rethrow.
 * Thay cho try/catch quanh `return client.get()` (try/catch không bắt reject của Promise).
 */
export function apiRequest<T>(promise: Promise<T>): Promise<T> {
  return promise.catch((err: unknown) => {
    handleError(err)
    throw err
  })
}

/** `location.search` / chuỗi query → params cho GET danh sách */
export function parseListQuery(querySt?: string): queryString.ParsedQuery<string> {
  return querySt ? queryString.parse(querySt) : {}
}
